<template>
  <div class="editPermission">
    <HearderTitle name="修改权限" />
    <table border="0" class="permission" width="100%">
      <tbody>
        <tr v-for="(permissionTop, topIndex) in tableData" :key="topIndex">
          <th style="line-height: 48px; border: 1px solid #edf3ff; padding: 0 10px; width: 150px">
            <el-checkbox :indeterminate="permissionTop.indeterminate" :key="topIndex" v-model="permissionTop.mychecked" :label="permissionTop.id" @change="onChangeTop(topIndex, permissionTop.id, $event)"> {{ permissionTop.title }}</el-checkbox>
          </th>
          <td class="td" style="border: 1px solid #edf3ff">
            <el-checkbox-group v-model="checkedCities">
              <el-checkbox v-model="permissionSon.mychecked" v-for="permissionSon in permissionTop.children" :key="permissionSon.id" @change="onChangeSon(topIndex, permissionSon.id, permissionTop.id, $event)" :label="permissionSon.id">{{ permissionSon.title }}</el-checkbox>
            </el-checkbox-group>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="btn_box">
      <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="seve()">提交</el-button>
      <el-button size="small" @click="cancel()" plain class="searchBtn">取消</el-button>
    </div>
  </div>
</template>

<script>
  import HearderTitle from '@/components/HearderTitle'
  import { editUserPermission, getUserPermission } from '@/api/user.js'
  export default {
    name: 'editPermission',
    data() {
      return {
        tableData: [],
        isIndeterminate: true,
        checkedCities: [],
        id: '',
      }
    },
    created() {
      let id = ''
      if (this.$route.params.id) {
        id = this.$route.params.id
        sessionStorage.setItem('roleId', id)
      } else {
        id = JSON.parse(sessionStorage.getItem('roleId'))
      }
      this.id = id
      this.userPermission()
    },
    methods: {
      async userPermission() {
        let { list, ids } = await getUserPermission({ id: this.id })
        this.tableData = list
        this.checkedCities = ids
        this.tableData.forEach((v2, i) => {
          if (this.checkedCities.indexOf(v2.id) !== -1) {
            this.tableData[i].mychecked = true
          }
        })
      },
      onChangeTop(index, topId, e) {
        //父级change事件
        let that = this
        that.tableData[index].mychecked = e //父级勾选后，子级全部勾选或者取消
        if (e == false) that.tableData[index].indeterminate = false //去掉不确定状态
        var childrenArray = that.tableData[index].children //这里注意是选取一级下的二级数据
        var len = childrenArray.length
        if (that.tableData[index].mychecked == true) {
          // 点击全选往v-model添加选中的id
          for (var i = 0; i < childrenArray.length; i++) {
            that.checkedCities.push(childrenArray[i].id)
            childrenArray[i].mychecked = true
          }
        } else {
          //取消全选删除重复的id
          that.checkedCities = that.checkedCities.filter((item) => !childrenArray.some((ele) => ele.id === item))
        }
      },
      onChangeSon(topIndex, sonId, topId, e) {
        //子级change事件
        let that = this
        //这里注意是选取一级下的二级数据
        var childrenArray = that.tableData[topIndex].children
        var tickCount = 0,
          unTickCount = 0,
          len = childrenArray.length
        for (var i = 0; i < len; i++) {
          if (sonId == childrenArray[i].id) childrenArray[i].mychecked = e
          if (childrenArray[i].mychecked == true) {
            tickCount++
          }
          if (childrenArray[i].mychecked == false) {
            unTickCount++
          }
        }
        if (tickCount == len) {
          //子级全勾选
          that.tableData[topIndex].mychecked = true
          that.tableData[topIndex].indeterminate = false
        } else if (unTickCount == len) {
          //子级全不勾选
          that.tableData[topIndex].mychecked = false
          that.tableData[topIndex].indeterminate = false
        } else {
          that.tableData[topIndex].mychecked = true
          //添加不确定状态
          that.tableData[topIndex].indeterminate = true
        }
      },
      async seve() {
        if (this.checkedCities.length <= 0) return this.$message.error('请选择权限')
        this.tableData.forEach((v) => {
          if (v.mychecked) {
            this.checkedCities.push(v.id)
          }
        })
        let ids = this.checkedCities
        let res = await editUserPermission({ id: this.id, ids })
        if (res.status !== 200) return this.$message.error('提交失败')
        return this.$message.success('提交成功')
      },
      cancel() {
        this.tableData.forEach((v2, i) => (this.tableData[i].mychecked = false))
        this.checkedCities = []
      },
    },
    components: { HearderTitle },
  }
</script>

<style lang="less">
  .editPermission {
    .permission {
      margin-top: 35px;
      border-collapse: collapse;
      .td {
        > div {
          display: flex;
          flex-direction: column;
          .el-checkbox {
            min-height: 40px;
            padding-left: 10px !important;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #edf3ff;
            margin-right: 0 !important;
            &:last-of-type {
              border-bottom: 0;
            }
          }
        }
      }
    }
    .btn_box {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
      margin-bottom: 20px;
      .searchBtn {
        width: 112px;
      }
    }
  }
</style>
